var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBarChart = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4H9V18H7V4ZM11 6H13V18H11V6ZM15 2H17V18H15V2ZM3 10H5V18H3V10Z",
    fill: "#3BBDED"
  })));
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBarChart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bar-chart.af5bf0ef.svg";
export { ForwardRef as ReactComponent };